export default {"src":"/_next/static/media/rhythm.6d076515.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};